import type { GradeQuizAnswerRow } from "./grade-quiz-response";
import type { QuizResponsePayload } from "./quiz-response-payload";

export function resolveQuizResponseAnswerId(
	answers: GradeQuizAnswerRow[],
	response: QuizResponsePayload,
): string {
	if (response.format === "MULTIPLE_CHOICE_SINGLE") {
		return response.selectedAnswerId;
	}
	if (
		response.format === "MULTIPLE_CHOICE_MULTI" &&
		response.selectedAnswerIds.length > 0
	) {
		return response.selectedAnswerIds[0];
	}
	if (response.format === "FILL_IN_BLANK") {
		const blank = answers.find((answer) => answer.role === "BLANK_FILL");
		if (blank) {
			return blank.id;
		}
	}
	if (response.format === "WORD_REORDER" && response.orderedAnswerIds[0]) {
		return response.orderedAnswerIds[0];
	}
	if (response.format === "RANK_ORDER" && response.orderedAnswerIds[0]) {
		return response.orderedAnswerIds[0];
	}
	if (response.format === "PAIR_MATCHING" && response.pairs[0]) {
		return response.pairs[0].leftId;
	}

	const fallback =
		answers.find((answer) => answer.role === "CORRECT") ?? answers[0];
	if (!fallback) {
		throw new Error("resolveQuizResponseAnswerId: question has no answers");
	}
	return fallback.id;
}
